import React from "react";
import {FlexCol} from "../components/generic/Containers";
import {LandingPageOverviewSections} from "../components/landingPage/LandingPageOverviewComponent";
import {TestimonialsComponent} from "../components/landingPage/TestimonialsComponent";
import {Footer} from "../components/Footer";
import {AboutMeSection, ContentTypesOverview, LearnFromExperts} from "../components/DashboardMainMenus";
import {HeroBanner} from "../components/landingPage/HeroBanner";
import {LandingPagedHeader, LandingPagedHeaderV3} from "../components/landingPage/LandingPageHeader";
import {FounderCompaniesComponent} from "../components/landingPage/FounderCompaniesComponent";
import {PainPointsComponent} from "../components/landingPage/PainPointsComponent";
import {HowItWorksComponent} from "../components/landingPage/HowItWorksComponent";
import {OverviewExamplesComponent} from "../components/landingPage/OverviewExamplesComponent";
import {ToolkitSectionComponent} from "../components/landingPage/ToolkitSectionComponent";
import {FinalCTASection} from "../components/landingPage/FinalCTASection";

export const LandingPage: React.FC<{navigate?: any}> = ({navigate}) => {

    return (
        <FlexCol padding={0} heightPercent={100} widthPercent={100}>
            <LandingPagedHeader isEducator={false}/>
            <FlexCol className={'landing-page-container'} widthPercent={90} maxWidth={80} alignSelf={"center"} gap={2}>
                <HeroBanner isEducator={false} />
                <FounderCompaniesComponent />
                <PainPointsComponent />
                <HowItWorksComponent />
                <ToolkitSectionComponent />
                {/*<OverviewExamplesComponent />*/}
                <LandingPageOverviewSections isEducator={false} />
                <TestimonialsComponent isEducator={false} />
                <AboutMeSection />
                <FinalCTASection />
                <Footer />
            </FlexCol>
        </FlexCol>
    );
};